/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CellStyleRequestedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellStyleRequestedEventArgs, _super);
    function CellStyleRequestedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._styleKey = null;
        _this._resolvedValue = null;
        _this._rowNumber = 0;
        return _this;
    }
    Object.defineProperty(CellStyleRequestedEventArgs.prototype, "styleKey", {
        get: function () {
            return this._styleKey;
        },
        set: function (a) {
            this._styleKey = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellStyleRequestedEventArgs.prototype, "resolvedValue", {
        get: function () {
            return this._resolvedValue;
        },
        set: function (a) {
            this._resolvedValue = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellStyleRequestedEventArgs.prototype, "rowNumber", {
        get: function () {
            return this._rowNumber;
        },
        set: function (a) {
            this._rowNumber = a;
        },
        enumerable: true,
        configurable: true
    });
    CellStyleRequestedEventArgs.$t = markType(CellStyleRequestedEventArgs, 'CellStyleRequestedEventArgs', EventArgs.$);
    return CellStyleRequestedEventArgs;
}(EventArgs));
export { CellStyleRequestedEventArgs };
//# sourceMappingURL=CellStyleRequestedEventArgs.js.map
